// note: general import
import * as React from "react";

// note: MUI import
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

// note: styles import
import styles from "styles/Progress.module.css";

// colors : secondary, success, inherit
export function MCCirculerBV1({ variant = "determinate", progress }) {
  return <CircularProgress variant={variant} value={progress} />;
}

export function MCCirculerNonValueBV2({ sx = "#265073", size }) {
  return <CircularProgress sx={sx} size={size} />;
}

export function MVCircularProgressWithLabelBV3(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export function MCLinearBV4({
  variant = "determinate",
  progress,
  isHasValue = false,
}) {
  return (
    <>
      {isHasValue ? (
        <LinearProgress variant={variant} value={progress} />
      ) : (
        <LinearProgress />
      )}
    </>
  );
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(36, 70, 140, 1)",
    }),
  },
}));

export function MCLinearProgressWithLabelBV5({
  value,
  textSx = { fontWeight: 600 },
  text,
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <BorderLinearProgress variant="determinate" value={value} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={textSx}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
}

export function Loader() {
  return <span className={styles["loader"]}></span>;
}
